// `String.fromCharCode(...bytes)` overflows the call stack on large payloads, so the bytes go in chunks.
const CHUNK_SIZE = 0x8000;
export const bytesToBase64 = (bytes) => {
    let binary = '';
    for (let offset = 0; offset < bytes.length; offset += CHUNK_SIZE) {
        binary += String.fromCharCode(...bytes.subarray(offset, offset + CHUNK_SIZE));
    }
    return btoa(binary);
};
